import { render, staticRenderFns } from "./rePassword.vue?vue&type=template&id=cb64fbf6&scoped=true"
import script from "./rePassword.vue?vue&type=script&lang=js"
export * from "./rePassword.vue?vue&type=script&lang=js"
import style0 from "./rePassword.vue?vue&type=style&index=0&id=cb64fbf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb64fbf6",
  null
  
)

export default component.exports